import {
  base64UrlDecode,
  base64UrlEncode,
  getRandomString,
} from '../../../../utils/string';

export class EidState {
  private readonly state: { token: string; redirectPath: string };

  constructor(state?: { token: string; redirectPath: string }) {
    this.state = state ?? {
      token: getRandomString(),
      redirectPath: window.location.pathname,
    };
  }

  get token() {
    return this.state.token;
  }

  toBase64URL() {
    return base64UrlEncode(JSON.stringify(this.state));
  }

  static fromBase64URL(data: string) {
    try {
      const state = JSON.parse(base64UrlDecode(data)) as {
        token: string;
        redirectPath: string;
      };

      return new EidState(state);
    } catch {
      return undefined;
    }
  }
}
